import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { parseCssStringToObject } from "../../../../helper";
import { DEFAULT_BLOCK_CSS } from "../../../../constant/constant";
import { useApp } from "../../../../context/AppState";
import getSymbolFromCurrency from "currency-symbol-map";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const ImageCarousel = ({ popupData, section, handleClose }) => {
  const { isMobile, appState } = useApp();
  const currencySymbol = appState?.is_preview_mode
    ? getSymbolFromCurrency(appState?.shop?.currency)
    : getSymbolFromCurrency(window?.Shopify?.currency?.active);

  const [swiperInstance, setSwiperInstance] = useState(null);

  const swiperRef = useRef(null);
  const Images = section.sections || [];
  const blockCSS = {
    ...DEFAULT_BLOCK_CSS,
    ...section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"],
    ...parseCssStringToObject(
      section?.setting?.overrideCss?.[isMobile ? "mobile" : "desktop"]
    ),
  };

  const buttonStyle = {
    background: "white",
    padding: "0",
    width: "40px",
    height: "40px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    transition: "background 0.2s ease",
    borderRadius: "3px",
    border: "1px solid #D4D4D4",
  };

  const buttonContainerStyle = {
    position: "absolute",
    bottom: "10px",
    zIndex: "10",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "space-between",
    width: "100px",
  };

  return (
    <div
    style={{
      ...blockCSS,
      // pointerEvents: appState?.is_preview_mode ? "none" : "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
      position: "relative",
    }}
  >
    {Images.length > 1 && (
      <div style={buttonContainerStyle}>
        <button
          onClick={() => swiperInstance?.slidePrev()}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#D4D4D4")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
          style={buttonStyle}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2">
            <path d="M15 18l-6-6 6-6" />
          </svg>
        </button>
        <button
          onClick={() => swiperInstance?.slideNext()}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#D4D4D4")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "white")}
          style={buttonStyle}
        >
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2">
            <path d="M9 18l6-6-6-6" />
          </svg>
        </button>
      </div>
    )}
    {Images.length > 0 ? (
      <Swiper
        ref={swiperRef}
        onSwiper={setSwiperInstance}
        pagination={{ clickable: true }}
        loop={true}
        style={{ width: "98%",height:"100%",pointerEvents: appState?.is_preview_mode ? "none" : "auto", }}
      >
        {Images.map((image, index) => (
          <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center" }}>
            <img
              src={image?.src?.image}
              alt={`Image ${index}`}
              style={{ maxWidth: "100%", height: "auto", }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    ) : (
      <p>No Image available</p>
    )}
  </div>
  );
};

export default ImageCarousel;
